import React, { Component } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import "../../../components/admin/css/common.css";
import sweetAlert, {
  sweetStatusAlert,
  sweetConfirmAlert
} from "../../../components/common/SweetAlert.js";
import Spinner from "react-bootstrap/Spinner";
import PageSpinner from "../../../components/common/spinner/PageSpinner.js";
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell
} from "@mui/material";
import MaterialCustomTablePagination from "../../../components/common/MaterialCustomTablePagination.js";
import debounce from "lodash.debounce";
import SimpleReactValidator from "simple-react-validator";
import { assessAuthorService } from "../../../service/settings/assessment/authorService.js";
import { authorTypeService } from "../../../service/settings/manage/author_type.service.js";
import ContentWrapper from "../../../components/common/ContentWrapper.js";
import config from '../../../helper/config.js';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import {customerConstants} from "../../../helper/constants.js";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let addBtnStyle, closeBtnStyle;
const customer = getCustomerFeatureFlag();
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    break;
  case customerConstants.EXO_CUSTOMER2:
    closeBtnStyle = {
      color: "var(--maincolor-cmc)",
      backgroundColor: "#E5F5FF",
      borderColor: "transparent",
    };
    addBtnStyle = {
      color: "#fff",
      backgroundColor: "var(--maincolor-cmc)",
      borderColor: "transparent",
    };
    break;
  default:
    break;
}

export default class extends Component {
  constructor(props) {
    super(props);
    this.createValidationsInstance();
    this.state = {
      showModal: false,
      author_id: "",
      author: "",
      ref_id: null,
      author_type_id: "",
      show_logo: false,
      logo_content: null,
      authors: [],
      authorTypes: [],
      isModified: false,
      showInsertModal: false,
      limit: 10, 
      offset: 0,
      sort_column: "author_id",
      sort_direction: "ASC",
      search_term: "",
      totalAuthors: 10,
      isTableDataLoading: true,
      currentPage: 0,
      editVisibility: true,
      addVisibility: true,
      deleteVisibility: true,
      isLoading: false,
    };

    // Debounced version of handleSearch function
    this.debouncedHandleSearch = debounce(this.fetchAllAuthors, 2000);
  }

  // Reset the form fields to initail values on update, insert, edit modal close and add modal close
  resetFormFields = () => {
    this.setState({
      author: "",
      author_type_id: "",
      ref_id: null,
    });
  };

  componentDidMount() {
    this.getAllAuthorTypes();
    this.fetchAllAuthors();
  }

  // Creating validator instance without any custom rules
  createValidationsInstance() {
    this.validator = new SimpleReactValidator();
  }

  getAllAuthorTypes = async() => {
    this.setState({ isLoading: true });
    await authorTypeService.getAllAuthorTypes()
    .then((response) => {
        if (response.success) {
        this.setState({
            authorTypes: response.data.author_types
        });
        } else {
        sweetStatusAlert(
            "Failed!",
            "Error fetching Author Types. Please refresh the screen!",
            "error"
        );
        }
    })
    .catch((error) => {
        sweetStatusAlert(
        "Failed!",
        "Error fetching Author Types. Please refresh the screen!",
        "error"
        );
    })
    .finally(() => {
        this.setState({ isLoading: false });
    });
  }

  getAuthorTypeName(author_type_id) {
		if (author_type_id !== null) {
			const author_type = this.state.authorTypes?.find(
				(author_type) => author_type.author_type_id == parseInt(author_type_id)
			);
			return author_type?.name;
		}
		else {
			return "N/A";
		}
	}
  
  //fetching available authors count for pagination using specific search_term
  fetchAllAuthors = async () => {
    const { limit, offset, sort_column, sort_direction, search_term } = this.state;
    await assessAuthorService.getAllAssessmentAuthors(limit, offset, sort_column, sort_direction, search_term)
      .then((response) => {
        if (response.success) {
          this.setState({
            authors: response.data.authors,
            totalAuthors: parseInt(response.data.total_count),
          });
        } else {
          sweetStatusAlert(
            "Failed!",
            "Error fetching authors. Please refresh the screen!",
            "error"
          );
        }
      })
      .catch((error) => {
        // Handle any error that occurred during the API call
        sweetStatusAlert(
          "Failed!",
          "Error fetching authors. Please refresh the screen!",
          "error"
        );
      })
      .finally(() => {
        this.setState({ isTableDataLoading: false }); // Set isTableDataLoading to false after data is fetched
      });
  };

  // Handle the data fetching as per the offset(page no) changes
  handlePageChange = (event, newPage) => {
    const { limit } = this.state;
    const newOffset = newPage * limit;
    this.setState(
      {
        offset: newOffset,
        isTableDataLoading: true,
        currentPage: newPage,
      },
      () => {
        this.fetchAllAuthors();
      }
    );
  };

  handlePageOffsetChange = (newOffset, newPage) => {
    this.setState(
      {
        offset: newOffset,
        isTableDataLoading: true,
        currentPage: newPage
      },
      () => {
        this.fetchAllAuthors();
      }
    );
  };

  // handle the data fetching as per the data per page limit gets changess
  handleRowsPerPageChange = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    const newPage = Math.floor(this.state.offset / newLimit);
    this.setState(
      {
        limit: newLimit,
        offset: newLimit * newPage,
        isTableDataLoading: true,
        currentPage: newPage,
      },
      () => {
        this.fetchAllAuthors();
      }
    );
  };

  handleSortChange = (sort_column) => {
        // If the same column is clicked, toggle the sort direction
        const { sort_column: currentSortColumn, sort_direction } = this.state;
        const newSortDirection =
            currentSortColumn === sort_column && sort_direction === "ASC"
                ? "DESC"
                : "ASC";

        this.setState(
            {
                sort_column,
                sort_direction: newSortDirection,
                offset: 0, // Reset offset when changing sorting
                currentPage: 0,
                isTableDataLoading: true,
            },
            () => {
                this.fetchAllAuthors();
            }
        );
    };

  // handle search text as per the regex validation and search_term , and fetch data as per the debounce
  handleSearch = (event) => {
    const search_term = event.target.value.trim();
    const regex = /^[a-zA-Z0-9][a-zA-Z0-9@\s.&]*$/;

    if (search_term === "" || regex.test(search_term)) {
      this.setState(
        {
          search_term,
          isTableDataLoading: true,
          offset: 0,
          currentPage: 0,
          searchError: false,
        },
        () => {
          this.debouncedHandleSearch();
        }
      );
    } else {
      this.setState({ search_term, searchError: true });
    }
  };

  // Toggle out the state of add form modal
  toggleAddAuthorModal = () => {
    this.setState((prevState) => ({
      showInsertModal: !prevState.showInsertModal,
    }));
  };

  // Toggle out the state of update form modal
  toggleUpdateAuthorModal = (author_id, author, ref_id, author_type_id, show_logo, logo_content) => {
    this.setState((prevState) => ({
      showModal: !prevState.showModal,
      author_id: author_id,
      author: author,
      ref_id: ref_id,
      author_type_id: author_type_id,
      show_logo: show_logo,
      logo_content: logo_content,
    }));
  };

  // Sets the value of a specific state based on the value provided to the respective element based on its assigned name
  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState(() => ({ [name]: value, isModified: true }));
  };

  handleChangeAuthorType = (event) => {
    event.preventDefault();
    this.setState({ author_type_id: event.target.value });
  };

  handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        this.setState({ logo_content: reader.result });
      };
      reader.readAsDataURL(file);
    }
  };
  
  // Pop up a sweet alert on edit or add modal and change its toggle state based on the input given to that sweet alert
  handleSweetAlert = (toggleFunction, modalVisibility) => {
    if (this.state.isModified) {
      sweetAlert().then((response) => {
        this.validator.hideMessages();
        this.validator.purgeFields();
        this.resetFormFields();
        this.setState(() => ({
          [modalVisibility]: response,
          isModified: false,
        }));
      });
    } else {
      this.validator.hideMessages();
      this.validator.purgeFields();
      this.resetFormFields();
      toggleFunction();
    }
  };

  // Make post request based on the fields validity and create the authors based on the state
  handleSubmit = async (event) => {
    event.preventDefault();

    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
    } else {
      this.setState({ isLoading: true });

      const { author, ref_id, author_type_id, show_logo, logo_content } = this.state;
      const newAuthor = { author: author, ref_id: ref_id, type_id: author_type_id, show_logo: show_logo, logo_content: logo_content };

      await assessAuthorService.createAuthor(newAuthor)
        .then((response) => {
          this.setState({ isLoading: false });
          if (response.success) {
            this.setState({ showInsertModal: false });
            sweetStatusAlert("Success!", response.message.success, "success");
            this.validator.hideMessages();
            this.validator.purgeFields();
            this.resetFormFields();
            this.fetchAllAuthors();
          } else {
            sweetStatusAlert("Failed!", response.message, "error");
          }
        })
        .catch(() => {
          this.setState({ isLoading: false });
          sweetStatusAlert("Failed !", "Unable to create new author", "error");
        });
    }
  };

  // Make put request based on the fields validity and updation of necessary states
  handleUpdateSubmit = async (event) => {
    event.preventDefault();

    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
    } else {
      this.setState({ isLoading: true });

      const authorItem = {
        author: this.state.author,
        ref_id: this.state.ref_id,
        type_id: this.state.author_type_id,
        show_logo: this.state.show_logo,
        logo_content: this.state.logo_content,
      };

      const authorId = this.state.author_id;
      await assessAuthorService.update(authorItem, authorId)
        .then((response) => {
          this.setState({ isLoading: false });
          if (response.success) {
            this.setState({ showModal: false });
            sweetStatusAlert(
              "Success!",
              "Author information updated successfully..!",
              "success"
            );
            this.validator.hideMessages();
            this.validator.purgeFields();
            this.resetFormFields();
            this.fetchAllAuthors();
          } else {
            sweetStatusAlert("Failed!", response.message, "error");
          }
        })
        .catch((error) => {
          this.setState({ isLoading: false });
          sweetStatusAlert(
            "Failed !",
            "Unable to update the author information",
            "error"
          );
        });
    }
  };

  handleDeleteAuthor = (obj) => {
    sweetConfirmAlert().then(() => {
      this.setState({ isLoading: true });
      assessAuthorService.deleteAuthor(obj)
        .then((response) => {
          this.setState({ isLoading: false });
          if (response.success) {
            sweetStatusAlert("Success!", response.message.success, "success");
            this.fetchAllAuthors();
          } else {
            sweetStatusAlert("Failed!", response.message, "error");
          }
        })
        .catch((error) => {
          this.setState({ isLoading: false });
          sweetStatusAlert("Oops!", "Error while deleting the author", "info");
        });
    });
  };

  //Rendering the necessary components based on the logic
  render() {
    const {
      limit,
      authors,
      totalAuthors,
      isTableDataLoading,
      currentPage,
      editVisibility,
      addVisibility,
      deleteVisibility,
      isLoading,
    } = this.state;
    this.validator.purgeFields();
    return (
      <>
        <ContentWrapper>
          <div className="row justify-content-between align-items-center py-5 mb-3">
            <div className="col-md-6 col-6">
              <h3 className="text-nowrap">Manage Authors</h3>
            </div>
            <div>
              {addVisibility && (
                <Button
                  className="insert-btn"
                  variant="primary"
                  onClick={() => this.toggleAddAuthorModal(true)}
                >
                  Add Author
                </Button>
              )}
            </div>
          </div>
          <div>
            <Form.Group controlId="exampleForm.ControlInput1" className="mb-2">
              <Form.Control
                type="text"
                placeholder="Search"
                onChange={this.handleSearch}
                isInvalid={this.state.searchError}
                // style={{ width: "18%" }}
                className="col-md-3 col-12"
              />
              {this.state.searchError && (
                <Form.Control.Feedback type="invalid">
                  Invalid input
                </Form.Control.Feedback>
              )}
            </Form.Group>
            {isLoading && (
              <PageSpinner id="show" text="Loading, Please wait!" />
            )}
            {isTableDataLoading ? (
              <div
                className="loading-container"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "75vw",
                  height: "90vh",
                }}
              >
                <Spinner animation="border" role="status">
                  <span className="sr-only">Loading...</span>
                </Spinner>
              </div>
            ) : authors.length > 0 ? (
              <div style={{ width: "80vw", height: "90vh", overflow: "auto" }}>
                <Table>
                  <TableHead>
                    <TableRow>
                        <TableCell
                            className="thead"
                            style={{ cursor: "pointer" }}
                            onClick={() => this.handleSortChange("author_id")}
                        >
                            No{" "}
                            {this.state.sort_column === "author_id" && (
                            <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                            )}
                        </TableCell>
                        <TableCell
                            className="thead"
                            style={{ cursor: "pointer" }}
                            onClick={() => this.handleSortChange("author")}
                        >
                            Name{" "}
                            {this.state.sort_column === "author" && (
                            <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                            )}
                        </TableCell>
                        <TableCell
                            className="thead"
                            style={{ cursor: "pointer" }}
                            onClick={() => this.handleSortChange("author_type_id")}
                        >
                            Type{" "}
                            {this.state.sort_column === "author_type_id" && (
                            <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                            )}
                        </TableCell>
                        <TableCell
                            className="thead"
                            style={{ cursor: "pointer" }}
                            onClick={() => this.handleSortChange("ref_id")}
                        >
                            Reference ID{" "}
                            {this.state.sort_column === "ref_id" && (
                            <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                            )}
                        </TableCell>
                        {(editVisibility || deleteVisibility) && (
                        <TableCell className="thead">Actions</TableCell>
                        )}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {authors.map((authorItem) => (
                      <TableRow key={authorItem.author_id}>
                        <TableCell className="tData">
                          {authorItem.author_id}
                        </TableCell>
                        <TableCell className="tData">
                          {authorItem.author}
                        </TableCell>
                        <TableCell className="tData">
                          {authorItem.type_id !== null ? this.getAuthorTypeName(authorItem.type_id) : 'N/A'}
                        </TableCell>
                        <TableCell className="tData">
                          {authorItem.ref_id === null ? 'N/A' : authorItem.ref_id}
                        </TableCell>
                        {(editVisibility || deleteVisibility) && (
                          <TableCell>
                            <div className="btn-group">
                              {editVisibility && (
                                <Button
                                  onClick={() =>
                                    this.toggleUpdateAuthorModal(
                                      authorItem.author_id,
                                      authorItem.author,
                                      authorItem.ref_id,
                                      authorItem.type_id,
                                      authorItem.show_logo,
                                      authorItem.logo_content,
                                    )
                                  }
                                  className="btn btn-icon btn-primary btn-sm m-1 edit-assement-btn flaticon-edit-icon"
                                  title="Edit Details"
                                />
                              )}
                              {deleteVisibility && (
                                <Button
                                  onClick={() =>
                                    this.handleDeleteAuthor(authorItem)
                                  }
                                  className="btn btn-icon btn-danger btn-sm m-1 delete-assement-btn flaticon-delete"
                                  title="Delete"
                                />
                              )}
                            </div>
                          </TableCell>
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <MaterialCustomTablePagination
                  totalCount = {totalAuthors}
                  currentPage = {currentPage}
                  limit = {limit}
                  handlePageChange = {this.handlePageChange}
                  handleRowsPerPageChange = {this.handleRowsPerPageChange}
                  handlePageOffsetChange = {this.handlePageOffsetChange}
                  offset = {this.state.offset}
                  rowsPerPageOptions={[5, 10, 20]}
                />
              </div>
            ) : (
              <div
                className="text-center mb-5 mt-10"
                style={{ height: "90vh" }}
              >
                <label>No authors/modules/units Available!</label>
              </div>
            )}
          </div>
        </ContentWrapper>

        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={this.state.showInsertModal}
          onHide={() =>
            this.handleSweetAlert(this.toggleAddAuthorModal, "showInsertModal")
          }
        >
          <Modal.Header closeButton>
            <Modal.Title>Create New Author</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="mb-4">
                <Form.Group as={Col} md="6" controlId="formAuthorName">
                  <Form.Label>Name*</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter the author name..."
                    name="author"
                    value={this.state.author}
                    onChange={this.handleChange}
                  />
                  {this.validator.message(
                    "author",
                    this.state.author,
                    "required|max:30",
                    {
                      className: "text-danger",
                      messages: {
                        required: "The name field is required.",
                        max: "The name should not be greater than 30 characters.",
                      },
                    }
                  )}
                </Form.Group>
                <Form.Group as={Col} md="6" controlId="formRefId">
                  <Form.Label>Reference ID*</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter the teacher code/institute number..."
                    name="ref_id"
                    value={this.state.ref_id}
                    onChange={this.handleChange}
                  />
                  {this.validator.message(
                    "ref_id",
                    this.state.ref_id,
                    "max:10",
                    {
                      className: "text-danger",
                      messages: {
                        max: "The reference ID should not be greater than 10 characters.",
                      },
                    }
                  )}
                </Form.Group>
              </Row>
              <Row className="mb-4 align-items-center">
                <Form.Group as={Col} md="6" controlId="formAuthorType">
                  <Form.Label>Select Type*</Form.Label>
                  <Form.Select
                    id="author_type"
                    value={this.state.author_type_id || ""}
                    onChange={this.handleChangeAuthorType}
                    className="form-control"
                  >
                    <option value="" disabled hidden style={{ color: "#6c757d" }}>
                      Nothing Selected
                    </option>
                    {this.state.authorTypes.map((option, index) => (
                      <option key={index} value={option.author_type_id}>
                        {option.name}
                      </option>
                    ))}
                  </Form.Select>
                  {this.validator.message(
                    "author_type",
                    this.state.author_type_id,
                    "required",
                    {
                      className: "text-danger",
                    }
                  )}
                </Form.Group>
                <Form.Group as={Col} md="6" controlId="formAddLogoRadio">
                  <Form.Label>Do you want to add logo?*</Form.Label>
                  <div>
                    <Form.Check
                      inline
                      label="Yes"
                      name="show_logo"
                      type="radio"
                      id="show_logo_yes"
                      checked={this.state.show_logo === true}
                      onChange={() => this.setState({ show_logo: true })}
                    />
                    <Form.Check
                      inline
                      label="No"
                      name="show_logo"
                      type="radio"
                      id="show_logo_no"
                      checked={this.state.show_logo === false}
                      onChange={() => this.setState({ show_logo: false, logo_content: null })}
                    />
                  </div>
                  {this.validator.message(
                    "show_logo",
                    this.state.show_logo,
                    "required",
                    {
                      className: "text-danger",
                      messages: {
                        required: "Please select Yes or No.",
                      },
                    }
                  )}
                </Form.Group>
              </Row>
              {this.state.show_logo && (
                <Row className="mb-4">
                  <Form.Group as={Col} md="6" controlId="formLogoUpload">
                    <Form.Label>Upload Logo*</Form.Label>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={this.handleLogoUpload}
                    />
                    {this.state.logo_content && (
                      <div className="mt-3">
                        <strong>Preview:</strong>
                        <div style={{ maxWidth: "150px", marginTop: "10px" }}>
                          <img
                            src={this.state.logo_content}
                            alt="Logo Preview"
                            style={{ width: "100%", height: "auto" }}
                          />
                        </div>
                      </div>
                    )}
                    {this.validator.message(
                      "logo_content",
                      this.state.logo_content,
                      "required",
                      {
                        className: "text-danger",
                        messages: {
                          required: "Please upload a logo.",
                        },
                      }
                    )}
                  </Form.Group>
                </Row>
              )}
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              style={addBtnStyle}
              onClick={this.handleSubmit}
            >
              Save changes
            </Button>
            <Button
              id="modal-close-button"
              style={closeBtnStyle}
              onClick={() =>
                this.handleSweetAlert(
                  this.toggleAddAuthorModal,
                  "showInsertModal"
                )
              }
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={this.state.showModal}
          onHide={() =>
            this.handleSweetAlert(this.toggleUpdateAuthorModal, "showModal")
          }
        >
          <Modal.Header closeButton>
            <Modal.Title>Update Author Information</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
            <Row className="my-5">
                <Form.Group
                  as={Col}
                  md="6"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Name*</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter the author name..."
                    name="author"
                    value={this.state.author}
                    onChange={this.handleChange}
                  />
                  {this.validator.message(
                    "author",
                    this.state.author,
                    "required|max:30",
                    {
                      className: "text-danger",
                      messages: {
                        required: "The name field is required.",
                        max: "The name should not be greater than 30 characters.",
                      },
                    }
                  )}
                </Form.Group>
                <Form.Group
                  as={Col}
                  md="6"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Reference ID*</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter the teacher code/institute number..."
                    name="ref_id"
                    value={this.state.ref_id}
                    onChange={this.handleChange}
                  />
                  {this.validator.message(
                    "ref_id",
                    this.state.ref_id,
                    "max:10",
                    {
                      className: "text-danger",
                      messages: {
                        max: "The reference ID should not be greater than 10 characters.",
                      },
                    }
                  )}
                </Form.Group>
              </Row>
              <Row className="my-5">
                <Form.Group
                    as={Col}
                    md="6"
                    controlId="exampleForm.ControlInput1"
                >
                <Form.Label>Select Type*</Form.Label>
                <Form.Select
                        id="author_type"
                        value={this.state.author_type_id || ""}
                        onChange={this.handleChangeAuthorType}
                        className="form-control"
                    >
                        <option value="" disabled hidden style={{ color: "#6c757d" }}>Nothing Selected</option>
                        {this.state.authorTypes.map((option, index) => (
                        <option key={index} value={option.author_type_id}>
                            {option.name}
                        </option>
                        ))}
                </Form.Select>
                {this.validator.message(
                    "author_type",
                    this.state.author_type_id,
                    "required",
                    {
                    className: "text-danger",
                    }
                )}
                </Form.Group>
                <Form.Group as={Col} md="6" controlId="formAddLogoRadio">
                  <Form.Label>Do you want to add logo?*</Form.Label>
                  <div>
                    <Form.Check
                      inline
                      label="Yes"
                      name="show_logo"
                      type="radio"
                      id="show_logo_yes"
                      checked={this.state.show_logo === true}
                      onChange={() => this.setState({ show_logo: true })}
                    />
                    <Form.Check
                      inline
                      label="No"
                      name="show_logo"
                      type="radio"
                      id="show_logo_no"
                      checked={this.state.show_logo === false}
                      onChange={() => this.setState({ show_logo: false, logo_content: null })}
                    />
                  </div>
                  {this.validator.message(
                    "show_logo",
                    this.state.show_logo,
                    "required",
                    {
                      className: "text-danger",
                      messages: {
                        required: "Please select Yes or No.",
                      },
                    }
                  )}
                </Form.Group>
              </Row>
              {this.state.show_logo && (
                <Row className="mb-4">
                  <Form.Group as={Col} md="6" controlId="formLogoUpload">
                    <Form.Label>Upload Logo*</Form.Label>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={this.handleLogoUpload}
                    />
                    {this.state.logo_content && (
                      <div className="mt-3">
                        <strong>Preview:</strong>
                        <div style={{ maxWidth: "150px", marginTop: "10px" }}>
                          <img
                            src={this.state.logo_content}
                            alt="Logo Preview"
                            style={{
                              width: "100%",
                              height: "auto",
                              border: "1px solid #ccc",
                              borderRadius: "4px"
                            }}
                          />
                        </div>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger mt-2"
                          onClick={() => this.setState({ logo_content: null })}
                        >
                          Remove Logo
                        </button>
                      </div>
                    )}
                    {this.validator.message(
                      "logo_content",
                      this.state.logo_content,
                      this.state.show_logo ? "required" : "", 
                      {
                        className: "text-danger",
                        messages: {
                          required: "Please upload a logo."
                        }
                      }
                    )}
                  </Form.Group>
                </Row>
              )}
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="modal-btn"
              variant="primary"
              style={addBtnStyle}
              onClick={this.handleUpdateSubmit}
            >
              Save changes
            </Button>
            <Button
              className="modal-btn"
              id="modal-close-button"
              style={closeBtnStyle}
              onClick={() =>
                this.handleSweetAlert(this.toggleUpdateAuthorModal, "showModal")
              }
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
